
import TextField from "@material-ui/core/TextField";

import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";

export default function AcknowledgementPassword({
  setPassword,
  error,
  ...props
}) {
  const { t } = useTranslation();
  return (
    <div className={styles.sessionAcknowledgementPasswordBlock}>
      <div className={styles.label}>{props.label}</div>
      <div className={styles.acknowledgementPasswordContainer}>
        <TextField
          className={styles.acknowledgementPassword}
          variant="outlined"
          placeholder={t("coachingSummary.enterPassword")}
          type="password"
          error={error}
          helperText={error && "Invalid Credentials"}
          onChange={e => {
            setPassword(e.target.value);
          }}
        />
      </div>
    </div>
  );
}
